import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { overrideComponent, setOptions, postVerificationSizeUpdates, setMetadata } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepTeacherPersonalInfoComponent } from './components/StepTeacherPersonalInfoComponent';
import { setPhoneNumberValidator } from './lib/validators/validators';
import { StepSuccessComponent } from './components/StepSuccessComponent';
import { getQueryParamsByName } from './lib/utils/browser';

// @ts-ignore
overrideComponent('StepTeacherPersonalInfoComponent', StepTeacherPersonalInfoComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);

setOptions(defaultOptions);
googleTagManagerHook();

const origin = getQueryParamsByName('origin') || '';

setMetadata({
  postalCode: '',
  origin,
});

setPhoneNumberValidator();
postVerificationSizeUpdates();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

